var cache = require('../../models/cache'),
  configManager = require('../../config/configManager'),
  CONST_ERRORS = require('../../constants/errors'),
  CorsClient = require('../../libraries/cors'),
  generalUtility = require('../../utilities/generalUtility'),
  log = require('../../libraries/logger').getLoggerInstance('Base.Message.BinEnabled'),
  RSVP = require('rsvp');

var midasClient;

var publicMethods = {
  /**
   * Checks a bin for a bin configuration, this can be used to determine if we need to wait for device collection prior to sending a CCA Start request
   * @param {String} bin - The bin to look for a config
   * @param {String} OrgUnitId - SSO org unit id found on the JWT
   * @returns {boolean} does a bin config exist
   */
  process: function (bin, orgUnitId) {
    try {
      var defaultResponse = { ConfigsEnabled: true, 'ProfileDelay': configManager.getSystemConfig('defaultBinProfilingDelay') };
      log.info('Processing DeviceFingerprinter Bin Enabled message...');

      if (bin !== undefined) {
        var getConfigRequest = {
          bin: bin,
          orgUnitId: orgUnitId
        };

        if (midasClient === undefined) {
          midasClient = new CorsClient(cache.deviceFingerprinting.urls.base, true, configManager.getMerchantConfig().timeout)
        }

        return midasClient.post('/Bin/Enabled', getConfigRequest)
          .then(function (dfResponse) {
            if (dfResponse !== undefined && 'ConfigsEnabled' in dfResponse) {
              return dfResponse;
            } else {
              // Default to profile bin
              return defaultResponse;
            }
          })
        ['catch'](function (error) {
          log.warn('DF /Bin/Enabled failed: ' + JSON.stringify(error));
          return defaultResponse;
        });

      } else {
        return new RSVP.Promise(function (resolve, reject) { reject('Invalid bin found: [' + bin + ']'); })
      }
    } catch (error) {
      generalUtility.handleError(error, CONST_ERRORS.GENERAL.NUMBER, CONST_ERRORS.GENERAL.DESCRIPTION);
    }
  }
};

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./messages/DeviceFingerprinter/binEnabled.js
// module id = 63
// module chunks = 5